<div class="flyout-site-check">
  <div class="flyout-site-check-header">
    <div>
      <h3 class="flyout-site-check-title">{{ "settings.dimensions.site-check.flyout-title" | translate }}</h3>
      @if (checkedAt(); as checked) {
        <p class="flyout-site-check-meta">
          {{ "settings.dimensions.site-check.flyout-meta" | translate: { count: pagesChecked(), time: (checked | formatDate) } }}
        </p>
      }
    </div>
    <button type="button" class="flyout-site-check-close" [attr.aria-label]="'generic.close' | translate" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="flyout-site-check-body">
    @if (activateRows().length) {
      <h4 class="flyout-site-check-section-title">{{ "settings.dimensions.site-check.recommended-title" | translate }}</h4>
    }
    @for (row of activateRows(); track row.type) {
      <div class="flyout-site-check-row">
        <svg class="flyout-site-check-icon flyout-site-check-icon--activate" viewBox="2 2 20 20" aria-hidden="true">
          <path
            d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
        <div class="flyout-site-check-row-content">
          <div class="flyout-site-check-row-heading">
            <span class="flyout-site-check-name">{{ row.labelKey | translate }}</span>
            @if (row.isActive) {
              <span class="flyout-site-check-badge">{{ "settings.dimensions.site-check.already-active" | translate }}</span>
            }
          </div>
          <p class="flyout-site-check-reason">{{ row.reasonText ?? (row.reasonKey | translate) }}</p>
          @if (row.level) {
            <p class="flyout-site-check-level">{{ "settings.dimensions.site-check.level-recommendation" | translate: { level: row.level } }}</p>
          }
          @if (row.examples.length) {
            <div class="flyout-site-check-examples">
              <span class="flyout-site-check-examples-label">{{ "settings.dimensions.site-check.examples" | translate }}</span>
              @for (value of row.examples; track value) {
                <span class="flyout-site-check-chip">{{ value }}</span>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (skipRows().length) {
      <h4 class="flyout-site-check-section-title">{{ "settings.dimensions.site-check.not-recommended-title" | translate }}</h4>
      @for (row of skipRows(); track row.type) {
        <div class="flyout-site-check-row flyout-site-check-row--skip">
          <svg class="flyout-site-check-icon" viewBox="2 2 20 20" aria-hidden="true">
            <path
              d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          </svg>
          <div class="flyout-site-check-row-content">
            <div class="flyout-site-check-row-heading">
              <span class="flyout-site-check-name">{{ row.labelKey | translate }}</span>
              @if (row.isActive) {
                <span class="flyout-site-check-badge">{{ "settings.dimensions.site-check.active-today" | translate }}</span>
              }
            </div>
            <p class="flyout-site-check-reason">{{ row.reasonText ?? (row.reasonKey | translate) }}</p>
            @if (row.examples.length) {
              <div class="flyout-site-check-examples">
                <span class="flyout-site-check-examples-label">{{ "settings.dimensions.site-check.examples" | translate }}</span>
                @for (value of row.examples; track value) {
                  <span class="flyout-site-check-chip">{{ value }}</span>
                }
              </div>
            }
          </div>
        </div>
      }
    }

    @if (missingDataNames(); as names) {
      <div class="flyout-site-check-structured-data">
        <p>{{ "settings.dimensions.site-check.missing-data" | translate: { names } }}</p>
        <a class="flyout-site-check-link" [href]="structuredDataHelpUrl" target="_blank" rel="noopener">
          {{ "settings.dimensions.site-check.structured-data-link" | translate }}
          <svg viewBox="3 3 18 18" aria-hidden="true">
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
          </svg>
        </a>
      </div>
    }
  </div>

  <div class="flyout-site-check-footer">
    <p class="flyout-site-check-changes">{{ changes().text }}</p>
    <button type="button" mat-flat-button class="primary-button flyout-site-check-apply" [disabled]="!changes().hasChanges" (click)="apply()">
      {{ "settings.dimensions.site-check.apply" | translate }}
    </button>
    <p class="flyout-site-check-hint">{{ "settings.dimensions.site-check.apply-hint" | translate }}</p>
  </div>
</div>
